import actionTypes from '../actions/actionTypes'
import slideTypes from 'helpers/enums/slideTypes'

const defaultState = {
	slides: {
	},
	current_slide: null,
	device_uid: null,
	headers: null,
	sessionType: null,
	current_status: {},
}

function initializeSession(state, action) {
	return {
		...state,
		device_uid: 't' + action.session.device_uid,
		current_slide: action.slide_uid,
		headers: action.session.headers,
		sessionType: action.session.sessionType,
		session_uid: action.session.session_uid,
		presentation_uid: action.session.presentation_uid,
		pincode: action.session.pincode,
		join_token: action.session.join_token,
	}
}

function initializeSlide(state, slideUid, slideState) {
	const newSlides = {...state.slides}
	newSlides[slideUid] = {
		...newSlides[slideUid],
		...slideState,
	}
	return {
		...state,
		slides: newSlides,
	}
}

function initializeOeq(state, action) {

	let slideState
	if (!state.slides[action.slide_uid]) {
		slideState = {
			title: action.questionData.title,
			reference_media: action.questionData.reference_media,
			slideIndex: action.slide.slideId,
			timer: action.slide.timer,
			question_key: action.questionData.question_key,
			type: slideTypes.SLIDE_TYPE_ID_OPEN_ENDED_QUESTION,
			participation: 0,
			answers: [],
		}
	} else {
		slideState = {
			timer: action.slide.timer,
		}
	}

	return initializeSession(initializeSlide(state, action.slide_uid, slideState), action)
}

function updateOEQStudentsData(state, action) {
	if (state.slides[action.slide_uid]) {
		return {
			...state,
			slides: {
				...state.slides,
				[action.slide_uid]: {
					...state.slides[action.slide_uid],
					participation: action.participation,
					answers: action.answers,
				},
			},
		}
	}
	return state
}

const teacherReducer = (state = defaultState, action) => {

	switch (action.type) {
		case actionTypes.SESSION_TEACHER_OEQ_INITIALIZE:
			return initializeOeq(state, action)
		case actionTypes.SESSION_TEACHER_OEQ_STUDENT_DATA_FETCHED:
			return updateOEQStudentsData(state, action)
		default:
			return state
	}
}

export default teacherReducer
